var Filter_Offres = {
	
	selected_type:"all",
	selected_sector:"all",
	selected_location:"all",
	
	init:function(){
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		if(urlParams.get('ville') != null){
			Filter_Offres.selected_location = urlParams.get('ville');
			Filter_Offres.filter_offres();
		}


		document.querySelector(".select-sector-container select").addEventListener("change", function(e){
			console.log("SECTOR FILTER CHANGE : " + e.target.value);
			Filter_Offres.selected_sector = e.target.value;
			Filter_Offres.filter_offres();
		});
		
		document.querySelector(".select-contract-container select").addEventListener("change", function(e){
			console.log("TYPE FILTER CHANGE : "  + e.target.value);
			Filter_Offres.selected_type = e.target.value;
			Filter_Offres.filter_offres();
		});
	},
	filter_offres:function(){
		console.log("FILTER OFFRES BY : sector : " + Filter_Offres.selected_sector + " / type : " + Filter_Offres.selected_type + " / type : " + Filter_Offres.selected_location );
		
		document.querySelectorAll(".listes-offres-container .offre").forEach(function(offre){
			offre.classList.remove("not-current-type");
			offre.classList.remove("not-current-sector");
			offre.classList.remove("not-current-location");
			
			if(Filter_Offres.selected_type != "all"){
				if(offre.getAttribute("data-type") != Filter_Offres.selected_type){
					offre.classList.add("not-current-type");
				}
			}
			if(Filter_Offres.selected_sector != "all"){
				if(offre.getAttribute("data-sector") != Filter_Offres.selected_sector){
					offre.classList.add("not-current-sector");
				}
			}
			if(Filter_Offres.selected_location != "all"){
				if(offre.getAttribute("data-location") != Filter_Offres.selected_location){
					offre.classList.add("not-current-location");
				}
			}


		})
		
	}
}
window.addEventListener('load', function(event) {
	if($(".listes-offres-container").length){
		Filter_Offres.init();	 
	}
});